import styled from 'styled-components';

const StyledRouteCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.borderMuted};
  border-radius: ${({ theme }) => theme.radii.sm};
  padding: 0.5rem;
  margin-bottom: 0.5rem;
`;

const StyledRow = styled.div`
  margin-bottom: 0.375rem;
`;

const StyledFieldLabel = styled.label`
  display: block;
  margin-bottom: 0.25rem;
  font-weight: 500;
  font-size: 13px;
`;

const StyledConditionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 0.25rem;
  font-weight: 500;
  font-size: 13px;
`;

const StyledFullWidthInput = styled.input`
  width: 100%;
`;

const StyledTextarea = styled.textarea`
  width: 100%;
  resize: vertical;
  font-family: monospace;
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

const StyledRemoveButton = styled.button`
  color: ${({ theme }) => theme.colors.dangerText};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  padding: 0.15rem 0.5rem;
`;

const StyledAddButton = styled.button`
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

const StyledMuted = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textMuted};
  font-weight: 300;
`;

export default {
  StyledRouteCard,
  StyledRow,
  StyledFieldLabel,
  StyledConditionLabel,
  StyledFullWidthInput,
  StyledTextarea,
  StyledRemoveButton,
  StyledAddButton,
  StyledMuted,
};
